import { Title, TitleProps } from '@mantine/core';

type Props = TitleProps;

function H4(props: Props) {
  return <Title fz={34} fs="normal" fw={300} {...props} />;
}

export default H4;
